export default __webpack_public_path__ + "static/media/correct.eb29c283.mp3";